import {
  CheckoutCustomerDetails,
  CheckoutDiscountProfileAttributesCC,
  CheckoutOffer,
  CustomerDetails,
  DiscountContent,
  QuoteResponse,
} from '@us-registration/util-models';
import { discounts } from '../constants/discounts';
export function getCustomerDetails(
  customer: CustomerDetails | undefined,
  quote: QuoteResponse | undefined
): CheckoutCustomerDetails | undefined {
  if (!customer) {
    return;
  }
  if (!quote) {
    return;
  }

  return {
    title: '',
    firstName: customer.firstName ?? '',
    lastName: customer.lastName ?? '',
    personId: quote.personId,
    address: {
      countryCode: customer.billingAddress.country,
      number: customer.billingAddress.line2,
      street: customer.billingAddress.line1,
      postalCode: customer.billingAddress.postalCode,
      stateCode: customer.billingAddress.state,
      city: customer.billingAddress.city,
    },
  };
}

export function constructOffer(
  quoteResponse: QuoteResponse,
  clickedPrepayCta: boolean
): CheckoutOffer {
  const offerPricing = quoteResponse.offer.contracts[0].contractAttributes;
  const offer = quoteResponse.offer;

  const annualOrMonthlyPricing =
    offerPricing.annualPrepay && clickedPrepayCta
      ? {
          ...offerPricing.annualPrepay,
        }
      : offerPricing.subscription
      ? {
          ...offerPricing.subscription,
        }
      : {};

  const { subscription, annualPrepay, ...contractAttributes } = offerPricing;

  return {
    ...offer,
    offerId: Number(quoteResponse.offer.offerId),
    contracts: [
      {
        ...offer.contracts[0],
        contractAttributes: {
          ...contractAttributes,
          ...annualOrMonthlyPricing,
        },
      },
    ],
  };
}
export function getDiscountDetails(
  quote: QuoteResponse
): DiscountContent | undefined {
  if (
    !quote ||
    !quote.offer.contracts[0].contractAttributes.subscription ||
    !quote.offer.contracts[0].contractAttributes.subscription.cc
      .discountProfileAttributes
  ) {
    return undefined;
  }

  const discountProfileCC = quote.offer.contracts[0].contractAttributes
    .subscription.cc
    .discountProfileAttributes as CheckoutDiscountProfileAttributesCC;

  const discountCode = discountProfileCC.ccDiscountCodeApplied;

  //Get the discount details from the discounts constant
  const discountDetails = discounts[discountCode];

  if (
    !discountProfileCC.discountPercentage ||
    !discountProfileCC.discountTerm
  ) {
    return undefined;
  }

  const subscription = discountDetails.subscription
    .replace(
      '{{ percentage }}',
      String(discountProfileCC.discountPercentage * 100)
    )
    .replace('{{ term }}', String(discountProfileCC.discountTerm));

  const banner = discountDetails.banner
    .replace(
      '{{ percentage }}',
      String(discountProfileCC.discountPercentage * 100)
    )
    .replace('{{ term }}', String(discountProfileCC.discountTerm));

  return {
    subscription,
    banner,
    discountCode: discountProfileCC.ccDiscountCodeApplied,
  };
}
